import { documentViewerDe, documentViewerEn } from "../components/documentViewerTranslations";
import { navigationDe, navigationEn, navigationRu } from "../navigation/navigationTranslations";
import { accountDe, accountEn } from "../account/accountTranslations";
import { sharedSettingsListDe, sharedSettingsListEn } from "../settings/settingsListTranslations";
import { sharedAccessEmailDe, sharedAccessEmailEn } from "../access-email/accessEmailTranslations";
import {
  sharedLegalFormDe,
  sharedLegalFormEn,
  sharedLegalFormIt,
  sharedLegalFormRu,
  sharedLegalFormUk,
} from "../legal/legalFormTranslations";
import {
  sharedSmtpDeliveryModeDe,
  sharedSmtpDeliveryModeEn,
  sharedSmtpDeliveryModeIt,
  sharedSmtpDeliveryModeRu,
  sharedSmtpDeliveryModeUk,
} from "../access-email/smtpDeliveryModeTranslations";
import {
  sharedAdminPlatformLogDe,
  sharedAdminPlatformLogEn,
  sharedAdminPlatformLogIt,
  sharedAdminPlatformLogRu,
  sharedAdminPlatformLogUk,
} from "../admin/adminPlatformLogTranslations";
import {
  sharedAdminFailureCircuitDe,
  sharedAdminFailureCircuitEn,
} from "../admin/adminFailureCircuitTranslations";
import { sharedAdminDe, sharedAdminEn, sharedAdminRu } from "../admin/adminTranslations";
import {
  sharedOfferedModelsDe,
  sharedOfferedModelsEn,
  sharedOfferedModelsIt,
  sharedOfferedModelsRu,
  sharedOfferedModelsUk,
} from "../ai/offeredModelsTranslations";
import {
  sharedProviderAccessDe,
  sharedProviderAccessEn,
  sharedProviderAccessIt,
  sharedProviderAccessRu,
  sharedProviderAccessUk,
} from "../ai/providerAccessTranslations";
import {
  sharedProviderPricingDe,
  sharedProviderPricingEn,
  sharedProviderPricingIt,
  sharedProviderPricingRu,
  sharedProviderPricingUk,
} from "../ai/providerPricingTranslations";
import {
  sharedAgentModelSelectionDe,
  sharedAgentModelSelectionEn,
  sharedAgentModelSelectionIt,
  sharedAgentModelSelectionRu,
  sharedAgentModelSelectionUk,
} from "../ai/agentModelSelectionTranslations";
import {
  sharedBillingDe,
  sharedBillingEn,
  sharedBillingIt,
  sharedBillingRu,
  sharedBillingUk,
} from "../billing/billingTranslations";
import {
  sharedPeriodSelectorDe,
  sharedPeriodSelectorEn,
  sharedPeriodSelectorIt,
  sharedPeriodSelectorRu,
  sharedPeriodSelectorUk,
} from "../components/periodSelectorTranslations";
import { sharedCommonDe, sharedCommonEn } from "../components/sharedCommonTranslations";
import { sharedSmtpRelayDe, sharedSmtpRelayEn } from "../smtp-relay/smtpRelayTranslations";
import {
  sharedStartupGateDe,
  sharedStartupGateEn,
  sharedStartupGateIt,
  sharedStartupGateRu,
  sharedStartupGateUk,
} from "../system/startupGateTranslations";
import { sharedManagedTableDe, sharedManagedTableEn, sharedManagedTableTranslations } from "../table/managedTableTranslations";
import { workforceDe, workforceEn } from "../workforce/workforceTranslations";

/**
 * Sammelwörterbuch aller Shared-Bausteine.
 *
 * Eine App merged **dieses eine** Objekt in ihr Dictionary — nicht die fünfzehn Einzeldateien.
 * Der Unterschied ist kein Komfort: Wird eine Shared-Komponente eingebunden, deren
 * Übersetzungsdatei die App nicht kennt, zeigt sie stumm ihre rohen Schlüssel auf Englisch. Genau
 * das passiert bei einer Liste, die je Modul gepflegt werden muss.
 *
 * Neue Shared-Übersetzungsdatei? Hier eintragen — dann haben alle Produkte sie sofort.
 *
 * Reihenfolge beim Mergen in der App: Shared **zuerst**, App-eigene Schlüssel danach, damit ein
 * Produkt eine Formulierung überschreiben kann.
 */
export const sharedTranslationsDe: Record<string, string> = {
  ...navigationDe, ...accountDe,
  ...sharedSettingsListDe,
  ...sharedLegalFormDe,
  ...sharedSmtpDeliveryModeDe,
  ...sharedCommonDe,
  ...sharedManagedTableDe,
  ...sharedStartupGateDe,
  ...sharedAccessEmailDe,
  ...sharedSmtpRelayDe,
  ...sharedAdminDe,
  ...sharedAdminPlatformLogDe,
  ...sharedAdminFailureCircuitDe,
  ...sharedPeriodSelectorDe,
  ...documentViewerDe,
  ...sharedOfferedModelsDe,
  ...sharedProviderAccessDe,
  ...sharedProviderPricingDe,
  ...sharedAgentModelSelectionDe,
  ...sharedBillingDe,
  ...workforceDe,
};

export const sharedTranslationsEn: Record<string, string> = {
  ...navigationEn, ...accountEn,
  ...sharedSettingsListEn,
  ...sharedLegalFormEn,
  ...sharedSmtpDeliveryModeEn,
  ...sharedCommonEn,
  ...sharedManagedTableEn,
  ...sharedStartupGateEn,
  ...sharedAccessEmailEn,
  ...sharedSmtpRelayEn,
  ...sharedAdminEn,
  ...sharedAdminPlatformLogEn,
  ...sharedAdminFailureCircuitEn,
  ...sharedPeriodSelectorEn,
  ...documentViewerEn,
  ...sharedOfferedModelsEn,
  ...sharedProviderAccessEn,
  ...sharedProviderPricingEn,
  ...sharedAgentModelSelectionEn,
  ...sharedBillingEn,
  ...workforceEn,
};

/**
 * Russisch, Ukrainisch und Italienisch decken nur die Bausteine ab, die diese Sprachen führen.
 * Produkte mit diesen Sprachen fallen für die übrigen Schlüssel auf Englisch zurück — sichtbar
 * unvollständig ist besser als ein leerer Text.
 */
export const sharedTranslationsRu: Record<string, string> = {
  ...navigationRu, ...accountEn,
  ...sharedManagedTableTranslations.ru,
  ...sharedLegalFormRu,
  ...sharedSmtpDeliveryModeRu,
  ...sharedStartupGateRu,
  ...sharedAdminRu,
  ...sharedAdminPlatformLogRu,
  ...sharedAdminFailureCircuitEn,
  ...sharedPeriodSelectorRu,
  ...sharedOfferedModelsRu,
  ...sharedProviderAccessRu,
  ...sharedProviderPricingRu,
  ...sharedAgentModelSelectionRu,
  ...sharedBillingRu,
};

export const sharedTranslationsUk: Record<string, string> = {
  ...navigationEn, ...accountEn,
  ...sharedManagedTableTranslations.uk,
  ...sharedLegalFormUk,
  ...sharedSmtpDeliveryModeUk,
  ...sharedStartupGateUk,
  ...sharedAdminPlatformLogUk,
  ...sharedAdminFailureCircuitEn,
  ...sharedPeriodSelectorUk,
  ...sharedOfferedModelsUk,
  ...sharedProviderAccessUk,
  ...sharedProviderPricingUk,
  ...sharedAgentModelSelectionUk,
  ...sharedBillingUk,
};

export const sharedTranslationsIt: Record<string, string> = {
  ...navigationEn, ...accountEn,
  ...sharedManagedTableTranslations.it,
  ...sharedLegalFormIt,
  ...sharedSmtpDeliveryModeIt,
  ...sharedStartupGateIt,
  ...sharedAdminPlatformLogIt,
  ...sharedAdminFailureCircuitEn,
  ...sharedPeriodSelectorIt,
  ...sharedOfferedModelsIt,
  ...sharedProviderAccessIt,
  ...sharedProviderPricingIt,
  ...sharedAgentModelSelectionIt,
  ...sharedBillingIt,
};

/** Nachschlagen nach Sprachkürzel; unbekannte Sprachen erhalten Englisch. */
export const sharedTranslations: Record<string, Record<string, string>> = {
  de: sharedTranslationsDe,
  en: sharedTranslationsEn,
  ru: sharedTranslationsRu,
  uk: sharedTranslationsUk,
  it: sharedTranslationsIt,
};

const LANGUAGE_CODE_LENGTH = 2;

export function resolveSharedTranslations(lang: string): Record<string, string> {
  const normalized = (lang || "").trim().toLowerCase().slice(0, LANGUAGE_CODE_LENGTH);
  return sharedTranslations[normalized] ?? sharedTranslationsEn;
}
